import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import EmployeeStatus from "./Pages/EmployeeStatus";
import ProtectedRoute from "./components/Navigation/ProtectedRoute";
import PublicRoute from "./components/Navigation/PublicRoute";
import Dashboard from "./Pages/Dashboard";
import EmployeeProfile from "./Pages/Profile"
import AddProject from "./Pages/Projects/AddProject";
import AddClient from "./Pages/Client/AddClient"
// import Documents from "./Pages/Employee/Documents";
import TimeSheet from "./Pages/Employee/TimeSheet";
import TimeOff from "./Pages/Employee/TimeOff";
import Login from "./Pages/Login";
import ForgotPassword from "./Pages/ForgotPassword";
import Reset from "./Pages/ResetPassword";
import UpdatePassword from "./Pages/UpdatePassword";
import EmployeeTable from "./Pages/Employee/EmployeeTable";
import NotFound from "./Pages/NotFound";
import Reports from "./Pages/Reports/index";
import PasswordExpired from "./Pages/Login/passwordExpired";
import AddEmployeeForm from "./Pages/Employee/EmployeeTable/AddEmployeeForm";
import EditEmployeeForm from "./Pages/Employee/EmployeeTable/EditEmployeeForm";
import AdminTimesheet from "./Pages/AdminTimesheet";
import Projects from "./Pages/Reports/Projects";
import Budget from "./Pages/Reports/Budget";
import Invoices from "./Pages/Invoices";
// import EmployeeDashboard from "./Pages/Dashboard/EmployeeDashboard";
import PendingTimesheet from "./Pages/AdminTimesheet/PendingTimesheet";
import PendingInvoice from "./Pages/Invoices/PendingInvoice";
import RejectedTimesheets from "./Pages/AdminTimesheet/RejectedTimesheets";
import ToBeInvoiced from "./Pages/AdminTimesheet/ToBeInvoiced";
import Events from "./Pages/Events";
import Birthdays from "./Pages/Events/Birthdays";
import Anniversaries from "./Pages/Events/Anniversaries";
import Quotes from "./Pages/Events/Quotes";
import AdminPreferences from "./Pages/AdminPreferences";
import ApprovedTimeOff from "./Pages/Employee/TimeOff/ApprovedTimeOff";
import RejectedTimeOff from "./Pages/Employee/TimeOff/RejectedTimeOff";


const App = () => {
  return (
      <Router >
        <Routes>
          <Route exact path="/" element={<ProtectedRoute />}>
            <Route exact path="/" element={<Dashboard />} />
            <Route exact path="/manageemployee" element={<EmployeeTable />} />
            <Route exact path="/addproject" element={<AddProject />} />
            <Route path="/profile" element={<EmployeeProfile />} />
            <Route exact path="/timesheets" element={<AdminTimesheet />} />
            <Route exact path="/timeoff" element={<TimeOff />} />
            <Route exact path="/approvedtimeoff" element={<ApprovedTimeOff />} />
            <Route exact path="/rejectedtimeoff" element={<RejectedTimeOff />} />
            {/* <Route exact path="/documents" element={<Documents />} /> */}
            <Route exact path="/addemployee" element={<AddEmployeeForm />} />
            <Route exact path="/editemployee/:id" element={<EditEmployeeForm />} />
            <Route exact path="/addemployeestatus/:id" element={<EmployeeStatus />} />
            <Route exact path="/updatePassword" element={<UpdatePassword/>}/>
            <Route exact path ="/addclient" element={<AddClient />}/>
            <Route exact path="/reports" element={<Reports />} />
            <Route exact path ="/passwordExpired" element={<PasswordExpired />}/>
            <Route exact path="/projects" element={<Projects/>}/>
            <Route exact path="/budget" element={<Budget/>}/>
            <Route exact path = "/invoices" element={<Invoices/>}/>
            {/* <Route exact path ="/emptimesheets" element={<EmployeeDashboard/>}/> */}
            <Route exact path ="/pendingTimesheets" element={<PendingTimesheet/>}/>
            <Route exact path = "/rejectedTimesheets" element={<RejectedTimesheets/>}/>
            <Route exact path ="/pendingInvoices" element={<PendingInvoice/>}/>
            <Route exact path = "/tobeinvoiced" element={<ToBeInvoiced/>}/>
            <Route exact path = "/events" element={<Events/>}/>
            <Route exact path = "/birthdays" element={<Birthdays/>}/>
            <Route exact path = "/anniversaries" element={<Anniversaries/>}/>
            <Route exact path = "/quotes" element={<Quotes/>}/>
            <Route exact path ="/adminPreferences" element={<AdminPreferences/>}/>
        </Route>
          <Route element={<PublicRoute />}>
            <Route path="/login" element={<Login />} />
            <Route path="/resetPassword" element={<ForgotPassword/>}/>
            <Route path="/resetpassword/:token" element={<Reset/>}/>
          </Route>
          <Route exact path="*" element={<NotFound/>} />
        </Routes>
      </Router>
  );
};

export default App;

